// extracted by mini-css-extract-plugin
export default {"templates":"AAXV2H"};